import { LoginLayout } from './Layout';
import { ForgotPasswordForm } from './ForgotPassword';

export const ResetPassword = () => {
  return (
    <LoginLayout>
      <ForgotPasswordForm />
    </LoginLayout>
  );
};
